import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import clsx from 'clsx';
import styles from './Question.module.scss.js';

var Question = function (_a) {
    var title = _a.title, desc = _a.desc, children = _a.children, className = _a.className, style = _a.style, onSkip = _a.onSkip;
    return (jsxs("div", __assign({ className: clsx(className), style: style }, { children: [jsxs("div", __assign({ className: styles.question }, { children: [jsx("h1", __assign({ className: styles.title }, { children: title })), jsxs("p", __assign({ className: styles.desc }, { children: [desc, desc && ' ', onSkip && (jsxs(Fragment, { children: ["If you are not sure, you can", ' ', jsx("button", __assign({ type: "button", onClick: onSkip }, { children: "skip this step" })), "."] }))] }))] })), jsx("div", __assign({ className: styles.children }, { children: children }))] })));
};

export { Question };
